import { render, staticRenderFns } from "./ConfigCategory.vue?vue&type=template&id=f105f35e&scoped=true&"
import script from "./ConfigCategory.vue?vue&type=script&lang=js&"
export * from "./ConfigCategory.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCategory.vue?vue&type=style&index=0&id=f105f35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f105f35e",
  null
  
)

export default component.exports